












import { defineComponent, computed, reactive, toRefs } from "@vue/composition-api"
import "../../../../ui/assets/mobile/css/common/rule-dialog.css"

export default defineComponent({
  props: ["ruleContent", "title"],

  setup() {
    const state = reactive({
      display: true,
      isShortVer: computed(() => {
        return document.body.clientHeight < 500
      })
    })

    const close = () => {
      state.display = false
    }

    return {
      ...toRefs(state),
      close
    }
  }
})
